export default __webpack_public_path__ + "static/media/sword.cdf41b94.png";